import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AviationEvent, AviationEventType, AviationEventTypeDesc } from '../models/aviation-event.model';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';


@Component({
  selector: 'app-event-summary-card',
  templateUrl: './event-summary-card.component.html',
  styleUrls: ['./event-summary-card.component.scss']
})
export class EventSummaryCardComponent implements OnInit, AfterViewInit {
  @Input() aviationEvent: AviationEvent;
  @Input() active: boolean;
  @Input() compact = false;
  @Input() interactive = false;
  @Output() eventMouseEnter = new EventEmitter<AviationEvent>();
  @Output() eventMouseLeave = new EventEmitter<AviationEvent>();
  aviationEventTypeDesc = AviationEventTypeDesc;
  aviationEventType = AviationEventType;

  @ViewChild('link') linkEl: ElementRef;

  private _touchStartX: number = null;
  private _touchStartY: number = null;

  constructor(private _router: Router) { }

  getDateString(aviationEvent: AviationEvent, dateType: string): string {
    let eventDate: moment;
    if (dateType === 'start') {
      eventDate = moment.tz(aviationEvent.startDateTime, 'UTC');
    } else {
      eventDate = moment.tz(aviationEvent.endDateTime, 'UTC');
    }
    const eventDateString = eventDate.clone().tz(aviationEvent.timezone).format('MM/DD/YYYY');
    return eventDateString;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    // Workaround to avoid having to double tap on the card to navigate to the airport detail page, without breaking
    // scrolling.
    this.linkEl.nativeElement.addEventListener('touchstart', e => this.onTouchStart(e), { passive: true });
    this.linkEl.nativeElement.addEventListener('touchend', e => this.onTouchEnd(e), { passive: true });
  }

  onHover(hover: boolean) {
    if (hover) {
      this.eventMouseEnter.emit(this.aviationEvent);
    } else {
      this.eventMouseLeave.emit(this.aviationEvent);
    }
  }

  onTouchStart(e: TouchEvent) {
    const touch = e.changedTouches[0];
    if (touch) {
      this._touchStartX = touch.pageX;
      this._touchStartY = touch.pageY;
    }
  }

  onTouchEnd(e: TouchEvent) {
    // If the page coordinates of the touchend event are the same as touchstart, then navigate to the airport detail
    // page.
    if (this.isTap(e)) {
      this._router.navigate(['/event', this.aviationEvent.eventId]);
    }
  }

  /**
   * Returns true if the page coordinates of the touch end event are the same as for touch start, indicating that the
   * action is a tap instead of scroll. (Note that binding to the "tap" event does not work - without setting passive
   * to true, it breaks scrolling, and without setting passive to true, the event never fires.)
   * @param {TouchEvent} e
   * @return {boolean}
   */
  isTap(e: TouchEvent) {
    const touch = e.changedTouches[0];
    return touch ? this._touchStartX === touch.pageX && this._touchStartY === touch.pageY : false;
  }
}
